import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { TranslateModule } from "@ngx-translate/core";

import { PresentationControlsComponent } from "./presentation-controls/presentation-controls.component";
import { PresentationInfoPanelComponent } from "./presentation-info-panel/presentation-info-panel.component";
import { PresentationModeComponent } from "./presentation-mode.component";
import { PresentationSettingsDialogComponent } from "./presentation-settings-dialog/presentation-settings-dialog.component";

@NgModule({
  declarations: [
    PresentationModeComponent,
    PresentationInfoPanelComponent,
    PresentationControlsComponent,
    PresentationSettingsDialogComponent
  ],
  imports: [CommonModule, ReactiveFormsModule, TranslateModule, FontAwesomeModule],
  exports: [PresentationModeComponent]
})
export class PresentationModeModule {}
